import React from "react";
import {CodPastPeriodsPage} from "../../pastPeriods/CodPastPeriodsPage";

export const MerchantPastPeriodsTab = ({isTabOpened = false}) => {
    return <CodPastPeriodsPage isFromCustomerTheme={true} isTabOpened={isTabOpened} />;
};
